<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ title }}</div>
    <div slot="body">
      <dialog-selected-tips :name="params.name" class="mt-3" :count="params.data.length" :action="title" />
      <dialog-table v-if="params.columns && params.columns.length" :data="params.data" :columns="columns" />
      <a-form-model
        ref="form"
        class="mt-3"
        :model="form"
        :rules="rules"
        v-bind="formItemLayout">
        <a-form-model-item :label="$t('report.notification_role')" prop="role_id" :extra="extra">
          <base-select
            v-model="form.role_id"
            resource="roles"
            :params="roleParams"
            :select-props="{placeholder: $t('common.tips.select', [$t('report.notification_role')])}" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t("dialog.ok") }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { validateModelForm } from '@/utils/validate'

export default {
  name: 'ReportChangeNotifyRoleDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        role_id: this.params.data[0].role_id || null,
      },
      roleParams: {
        limit: 20,
        scope: this.$store.getters.scope,
      },
      rules: {
        role_id: { required: true, message: this.$t('common.tips.select', [this.$t('report.notification_role')]) },
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
    }
  },
  computed: {
    title () {
      return this.$t('report.modify_notify_role')
    },
    columns () {
      const showColumns = ['name', 'enabled', 'role']
      return this.params.columns.filter(v => showColumns.includes(v.field))
    },
    extra () {
      let type = ''
      if (this.params.data[0].id.includes('system')) type = 'system'
      if (this.params.data[0].id.includes('domain')) type = 'domain'
      if (this.params.data[0].id.includes('project')) type = 'project'
      return type ? this.$t(`report.${type}.role_tip`) : ''
    },
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        await validateModelForm(this.$refs.form)
        await this.params.onManager('update', {
          id: this.params.data[0].id,
          managerArgs: {
            data: {
              role_id: this.form.role_id,
            },
          },
        })
        this.$message.success(this.$t('common.success'))
        this.cancelDialog()
      } catch (error) {
        throw error
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
